import { ReactNode, useState } from 'react'
import classnames from 'classnames'
import { TrackClick } from 'pages/certificates/tracking'
import { ExpandCollapseButton } from './ExpandCollapseButton'

interface FaqItemProps {
  question: string
  theme: 'light' | 'dark'
  children: ReactNode
}

const FaqItem = ({ question, theme, children }: FaqItemProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className='mb-7'>
      <TrackClick event='certificateLandingClick' enabled={!isOpen}>
        <button
          type='button'
          aria-expanded={isOpen}
          className='flex items-center mb-4 pt-7 border-t border-dashed border-c-base-900 mc-clickable w-full'
          onClick={() => setIsOpen(!isOpen)}
        >
          <h3 className='c-heading-3'>{question}</h3>
          <ExpandCollapseButton isExpanded={isOpen} theme={theme} />
        </button>
      </TrackClick>
      <div
        className={classnames(
          'grid transition-[grid-template-rows] duration-500 [&>div]:overflow-hidden',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        )}
      >
        <div>
          <div
            className={classnames('c-body-xlarge', {
              'text-c-text-tint-1': theme === 'dark',
              'text-c-text-tint-2': theme === 'light',
            })}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export { FaqItem }
